<template>
  <div>
    <v-card elevation style="border-radius: 16px">
      <v-form v-model="invitationForm">
        <v-text-field
          :rules="nameRules"
          v-model="userName"
          class="mx-10"
          prepend-icon="mdi-account"
          label="User Full Names"
        ></v-text-field>
        <v-text-field
          :rules="emailRules"
          v-model="userEmail"
          class="mx-10"
          prepend-icon="mdi-mail"
          label="User Email"
        ></v-text-field>
        <v-text-field
          :rules="nameRules"
          v-model="userPhone"
          class="mx-10"
          prepend-icon="mdi-phone"
          label="User Phone"
        ></v-text-field>

        <v-autocomplete
          v-if="sidOn"
          :items="students"
          v-model="userSid"
          class="mx-10"
          label="User SID"
          prepend-icon="mdi-numeric"
        ></v-autocomplete>

        <v-select
          class="mx-10"
          :rules="nameRules"
          prepend-icon="mdi-lock"
          :items="alevels"
          label="Access Level"
          v-model="userAccess"
        ></v-select>

        <v-radio-group v-model="radioGroup" class="mx-10">
          <v-radio
            :color="getThemeColor"
            :key="1"
            :label="`Invite Another User For ${getUserCompany.name}`"
            :value="1"
          ></v-radio>
          <v-radio
            color="green"
            :key="2"
            label="Invite A User For A Different Company"
            :value="2"
          ></v-radio>
        </v-radio-group>

        <v-card-actions>
          <v-spacer></v-spacer>

          <vButton
            color="teal"
            icon="mdi-account-plus"
            :outlined="false"
            label="Invite User"
            @button-clicked="InviteSomeone"
          >
          </vButton>
        </v-card-actions>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import vButton from "@/components/Legos/vButton.vue";

export default {
  props: {
    sidOn: {
      default: false,
    },
  },
  components: {
    vButton,
  },
  computed: {
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getThemeStyle() {
      return this.$store.getters.getThemeStyle;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getUserCompany() {
      return this.$store.getters.getUserCompany;
    },
  },
  data: () => ({
    radioGroup: 1,
    invitationForm: null,
    nameRules: [(v) => !!v || "Field is required"],
    emailRules: [
      (v) => !!v || "Email is required",
      (v) => /.+@.+/.test(v) || "E-mail must be valid",
    ],
    userName: null,
    userPhone: null,
    userEmail: null,
    userAccess: null,
    userSid: null,
    emis: null,
    alevels: [
      { text: "Everybody [1]", value: 1 },
      { text: "Staff [5]", value: 5 },
      { text: "Admin [7]", value: 7 },
      { text: "Manager [9]", value: 9 },
      { text: "Super Admin [11]", value: 11 },
    ],
  }),

  methods: {
    InviteSomeone() {
      if (!this.invitationForm) {
        this.$toast.error("All fields are required!", { duration: 5000 });
        return false;
      }
      this.$store.commit("setLoader", true);
      const user = {};
      user.userName = this.userName;
      user.userPhone = this.userPhone;
      user.userEmail = this.userEmail;
      user.userAccess = this.userAccess;

      if (this.sidOn) {
        user.userSid = this.userSid;
      }

      if (this.radioGroup === 2) {
        user.emis = null;
        user.userDomain = "127.0.0.1";
      } else {
        user.emis = this.getUserCompany.emis;
        user.userDomain = window.location.hostname;
      }

      axios
        .postDataWithToken("/auth/invite-someone", user, this.getAccessToken)
        .then((response) => {
          this.$store.commit("setLoader", false);
          if (response && response.status == "success") {
            this.$toast.success("Invitation Sent Successfully!");
            this.$emit("close-dialog");
          } else {
            this.$toast.error("Oops, Something Went Wrong!");
            this.$emit("close-dialog");
          }
        });
    },
  },
};
</script>

<style></style>
